import { Form, Input } from "antd";
import TextArea from "antd/es/input/TextArea";

type Props = {
  language: {
    id: string;
    code: string;
    name: string;
  };
  isGroup?: boolean;
};

const LanguageForm = ({ language, isGroup }: Props) => {
  return (
    <>
      <Form.Item
        name={`name${language.code}`}
        label={`Name (${language.code})`}
        rules={[
          {
            required: true,
            message: "name is required",
          },
          () => ({
            validator(_, values) {
              if (values[0] !== " ") {
                return Promise.resolve();
              }
              return Promise.reject(new Error("Space as a first letter is not allowed"));
            },
          }),
        ]}
      >
        <Input type="text" placeholder="name" />
      </Form.Item>
      <Form.Item
        name={`description${language.code}`}
        label={`Description (${language.code})`}
        rules={[
          {
            required: true,
            message: "description is required",
          },
          () => ({
            validator(_, values) {
              if (values[0] !== " ") {
                return Promise.resolve();
              }
              return Promise.reject(new Error("Space as a first letter is not allowed"));
            },
          }),
        ]}
      >
        <TextArea rows={2} />
      </Form.Item>
      <Form.Item
        name={`slug${language.code}`}
        label={`Slug (${language.code})`}
        rules={[{ required: true, message: "slug is required" }]}
      >
        <Input type="text" placeholder="slug" />
      </Form.Item>

      {isGroup && (
        <>
          <Form.Item
            name={`prefix${language.code}`}
            label={`Prefix`}
            rules={[{ required: true, message: "Predic is required" }]}
          >
            <Input type="text" placeholder="prefix" />
          </Form.Item>
          <Form.Item name={`ssr_title${language.code}`} label={`Ssr title`}>
            <Input type="text" placeholder="ssr title" />
          </Form.Item>
          <Form.Item name={`ssr_description${language.code}`} label={`Ssr description`}>
            <Input type="text" placeholder="ssr description" />
          </Form.Item>
        </>
      )}
    </>
  );
};

export default LanguageForm;
